export default {
  BT_CSHTFT: "ពិន្ទុត្រឹមត្រូវ ត្រូវបានបែងចែកពេលខាងក្រោម/លើ",
  BT_ETGHTFT: "គ្រាប់បាល់សរុបត្រឹមត្រូវ ខាងក្រោម/លើ",
  BS_CSHTFT: "ពិន្ទុត្រឹមត្រូវ ត្រូវបានបែងចែកពេលខាងក្រោម/លើ",
  BS_ETGHTFT: "ពេលវេលា និងគ្រាប់បាល់សរុបត្រឹមត្រូវ ខាងក្រោម/លើ",

  BT_O: "លើ",
  BT_U: "ក្រោម",

  BT_BOTH: "ទាំងពីរ",
  BT_ONE: "មួយ",
  BT_HDP: "ផ្តាច់ព្រ័ត្រ",
  BT_OU: "លើ/ក្រោម",
  BT_ML: "លទ្ធផលឯកតា",
  BT_1X2: "1X2",
  BT_1X2HDP: "ផ្តាច់ព្រ័ត្រ 3 វិធី",
  BT_CS: "ពិន្ទុត្រឹមត្រូវ",
  BT_OE: "គូ/សេស",
  BT_DC: "ឱកាសទ្វេដង",
  BT_HTFT: "ពាក់កណ្តាល/ពេញម៉ោង",
  BT_FGLG: "គ្រាប់ដំបូង/ចុងក្រោយ",
  BT_TG: "គ្រាប់បាល់សរុប",
  BT_OR: "ជើងឯក",
  BT_ORZ: "ជើងឯក",
  BT_ODD: "សេស",
  BT_EVEN: "គូ",

  BT_ANB: "ភ្ញៀវ មិនគិត",
  BT_BS: "ទាំងពីរ/មួយ/មិនមាន ធ្វើបានគ្រាប់",
  BT_CL: "រក្សាសំណាញ់ស្អាត",
  BT_DNB: "ស្មើ មិនគិត",
  BT_DNBH: "បាតទី១ ស្មើ មិនគិត",
  BT_HNB: "ម្ចាស់ផ្ទះ មិនគិត",
  BT_TWTN: "ឈ្នះដោយមិនបាត់គ្រាប់",

  BT_1X2OU: "1X2 + លើ/ក្រោម",
  BT_1O: "1 លើ",
  BT_1U: "1 ក្រោម",
  BT_2O: "2 លើ",
  BT_2U: "2 ក្រោម",
  BT_XO: "X លើ",
  BT_XU: "X ក្រោម",

  BS_DCOU: "ឱកាសទ្វេដង + លើ/ក្រោម",
  BT_DCOU: "ឱកាសទ្វេដង + លើ/ក្រោម",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "លើ/ក្រោម + សេស/គូ",
  BT_OUOE: "លើ/ក្រោម + សេស/គូ",
  BK_OO: "លើ/លើ",
  BK_OE: "លើ/សេស",
  BK_UO: "ក្រោម/លើ",
  BK_UE: "ក្រោម/សេស",

  BS_HTFTOE: "វគ្គទី១/ចប់ការប្រកួត + សេស/គូ",
  BT_HTFTOE: "វគ្គទី១/ចប់ការប្រកួត + សេស/គូ",
  BK_EO: "សេស/លើ",
  BK_EE: "សេស/សេស",

  BS_WM: "ភាពលើសលប់នៃការឈ្នះ",
  BT_WM: "ភាពលើសលប់នៃការឈ្នះ",
  BK_H1: "ម្ចាស់ផ្ទះ 1 គ្រាប់",
  BK_H2: "ម្ចាស់ផ្ទះ 2 គ្រាប់",
  BK_H3Up: "ម្ចាស់ផ្ទះ 3 គ្រាប់ឡើង",
  BK_A1: "ភ្ញៀវ 1 គ្រាប់",
  BK_A2: "ភ្ញៀវ 2 គ្រាប់",
  BK_A3Up: "ភ្ញៀវ 3 គ្រាប់ឡើង",
  BK_D: "ស្មើគ្នាមានបាល់ (មិនរាប់បញ្ចូល 0-0)",
  BK_NG: "គ្មានបាល់",

  BS_ETG: "ចំនួនគ្រាប់បាល់ជាក់លាក់",
  BT_ETG: "ចំនួនគ្រាប់បាល់ជាក់លាក់",
  BS_EHTG: "ចំនួនគ្រាប់បាល់ម្ចាស់ផ្ទះជាក់លាក់",
  BT_EHTG: "ចំនួនគ្រាប់បាល់ម្ចាស់ផ្ទះជាក់លាក់",
  BS_EATG: "ចំនួនគ្រាប់បាល់ភ្ញៀវជាក់លាក់",
  BT_EATG: "ចំនួនគ្រាប់បាល់ភ្ញៀវជាក់លាក់",
  BS_ETGH: "វគ្គទី១ ចំនួនគ្រាប់បាល់ជាក់លាក់",
  BT_ETGH: "វគ្គទី១ ចំនួនគ្រាប់បាល់ជាក់លាក់",
  BS_EHTGH: "វគ្គទី១ ចំនួនគ្រាប់បាល់ម្ចាស់ផ្ទះជាក់លាក់",
  BT_EHTGH: "វគ្គទី១ ចំនួនគ្រាប់បាល់ម្ចាស់ផ្ទះជាក់លាក់",
  BS_EATGH: "វគ្គទី១ ចំនួនគ្រាប់បាល់ភ្ញៀវជាក់លាក់",
  BT_EATGH: "វគ្គទី១ ចំនួនគ្រាប់បាល់ភ្ញៀវជាក់លាក់",
  BT_0: "0 គ្រាប់",
  BT_1: "1 គ្រាប់",
  BT_2: "2 គ្រាប់",
  BT_3: "3 គ្រាប់",
  BT_4: "4 គ្រាប់",
  BT_5: "5 គ្រាប់",
  BT_6Up: "6 គ្រាប់ឡើង",
  BT_3Up: "3 គ្រាប់ឡើង",

  BT_HDPH: "វគ្គទី១ ភារកិច្ច",
  BT_OUH: "វគ្គទី១ លើស/ក្រោម",
  BT_MLH: "វគ្គទី១ ការភ្នាល់ឈ្នះផ្ទាល់",
  BT_1X2H: "វគ្គទី១ 1X2",
  BT_1X2HDPH: "វគ្គទី១ ភារកិច្ច 3 ជម្រើស",
  BT_CSH: "វគ្គទី១ ការទស្សន៍ទាយពិន្ទុត្រឹមត្រូវ",
  BT_OEH: "វគ្គទី១ សេស/គូ",
  BT_DCH: "វគ្គទី១ ឱកាសពីរដង",
  BT_FGLGH: "វគ្គទី១ បាល់ដំបូង/ចុងក្រោយ",
  BT_TGH: "វគ្គទី១ ចំនួនគ្រាប់បាល់សរុប",

  TB_HDP: "ពេលវេលាពេញ បន្ទុកភារកិច្ច",
  TB_OU: "ពេលវេលាពេញ លើស/ក្រោម",
  TB_1X2: "ពេលវេលាពេញ 1X2",
  TB_OE: "ពេលវេលាពេញ សេស/គូ",
  TB_HDPH: "វគ្គទី១ បន្ទុកភារកិច្ច",
  TB_OUH: "វគ្គទី១ លើស/ក្រោម",
  TB_1X2H: "វគ្គទី១ 1X2",
  TB_OEH: "វគ្គទី១ សេស/គូ",

  BT_HDPOU: "បន្ទុកភារកិច្ច និង លើស/ក្រោម",
  BT_PARLAY: "ភ្នាល់បញ្ចូលច្រើន",
  BT_FT: "ពេលវេលាពេញ ",
  BT_1H: "វគ្គទី១ ",
  BT_2H: "វគ្គទី២ ",

  BT_FG: "គ្រាប់បាល់ដំបូង",
  BT_LG: "គ្រាប់បាល់ចុងក្រោយ",
  BT_HFG: "គ្រាប់ដំបូងក្រុមម្ចាស់ផ្ទះ",
  BT_AFG: "គ្រាប់ដំបូងក្រុមអ្នកអញ្ជើញ",
  BT_HLG: "គ្រាប់ចុងក្រោយក្រុមម្ចាស់ផ្ទះ",
  BT_ALG: "គ្រាប់ចុងក្រោយក្រុមអ្នកអញ្ជើញ",
  BT_NG: "គ្មានគ្រាប់បាល់",
  BT_HY: "ម្ចាស់ផ្ទះ បាទ",
  BT_HN: "ម្ចាស់ផ្ទះ ទេ",
  BT_AY: "ភ្ញៀវ បាទ",
  BT_AN: "ភ្ញៀវ ទេ",
  BT_H: "ម្ចាស់ផ្ទះ",
  BT_A: "ភ្ញៀវ",
  BT_D: "ស្មើ",
  BT_HD_DC: "ម្ចាស់/ស្មើ",
  BT_HA_DC: "ម្ចាស់/ភ្ញៀវ",
  BT_DA_DC: "ស្មើ/ភ្ញៀវ",
  BT_HH: "ម្ចាស់/ម្ចាស់",
  BT_HD: "ម្ចាស់/ស្មើ",
  BT_HA: "ម្ចាស់/ភ្ញៀវ",
  BT_DH: "ស្មើ/ម្ចាស់",
  BT_DD: "ស្មើ/ស្មើ",
  BT_DA: "ស្មើ/ភ្ញៀវ",
  BT_AH: "ភ្ញៀវ/ម្ចាស់",
  BT_AD: "ភ្ញៀវ/ស្មើ",
  BT_AA: "ភ្ញៀវ/ភ្ញៀវ",

  BT_Y: "បាទ",
  BT_N: "ទេ",

  BT_LIVE: "ផ្សាយផ្ទាល់",
  BT_Live: "ផ្សាយផ្ទាល់",
  BT_live: "ផ្សាយផ្ទាល់",
  BT_HT: "ពាក់កណ្ដាលពេល",
  BT_DELAYED: "ពន្យារពេល",
  BT_PEN: "បាល់បញ្ចប់ការប្រកួត",

  BT_FT1: "ពេញ.1",
  BT_FT2: "ពេញ.2",
  BT_FTX: "ពេញ.X",

  TC_FT1: "1",
  TC_FT2: "2",
  TC_FTX: "X",

  BT_HT1: "ពាក់កណ្ដាល.1",
  BT_HT2: "ពាក់កណ្ដាល.2",
  BT_HTX: "ពាក់កណ្ដាល.X",

  F5_INN_HDP: "F5 INN. ការប៉ាន់ប្រមាណ",
  F5_INN_OU: "F5 INN. លើស/ក្រោម",

  BS_HDP: "ពេញពេល ប៉ាន់ប្រមាណ",
  BS_HDPH: "ពាក់កណ្ដាលពេល ប៉ាន់ប្រមាណ",
  BS_OU: "ពេញពេល លើស/ក្រោម",
  BS_OUH: "ពាក់កណ្ដាលពេល លើស/ក្រោម",
  BS_OE: "ពេញពេល គូ/សេស",
  BS_OEH: "ពាក់កណ្ដាលពេល គូ/សេស",
  BS_1X2: "ពេញពេល 1X2",
  BS_1X2H: "ពាក់កណ្ដាលពេល 1X2",
  BS_ML: "ពេញពេល ប្រភេទជម្រើសឈ្នះ",
  BS_MLH: "ពាក់កណ្ដាលពេល ប្រភេទជម្រើសឈ្នះ",
  BS_1X2HDP: "ពេញពេល បីជម្រើស ប៉ាន់ប្រមាណ",
  BS_1X2HDPH: "ពាក់កណ្ដាលពេល បីជម្រើស ប៉ាន់ប្រមាណ",
  BS_CS: "ពេញពេល លទ្ធផលត្រឹមត្រូវ",
  BS_CSH: "ពាក់កណ្ដាលពេល លទ្ធផលត្រឹមត្រូវ",
  BS_DC: "ពេញពេល ឱកាសទ្វេដង",
  BS_DCH: "ពាក់កណ្ដាលពេល ឱកាសទ្វេដង",
  BS_FGLG: "ពេញពេល គ្រាប់ដំបូង/ចុងក្រោយ",
  BS_FGLGH: "ពាក់កណ្ដាលពេល គ្រាប់ដំបូង/ចុងក្រោយ",
  BS_TG: "ពេញពេល សរុបគ្រាប់បាល់",
  BS_TGH: "ពាក់កណ្ដាលពេល សរុបគ្រាប់បាល់",
  BS_ANB: "ភ្ញៀវ មិនភ្នាល់",
  BS_HTFT: "ពាក់កណ្ដាល/ពេញពេល",
  BS_BS: "ក្រុមទាំងអស់/មួយ/គ្មានការរកគ្រាប់",
  BS_CL: "ក្រុមរក្សាបាល់ស្អាត",
  BS_DNB: "ស្មើមិនភ្នាល់",
  BS_DNBH: "ពាក់កណ្ដាលពេល ស្មើមិនភ្នាល់",
  BS_HNB: "ម្ចាស់ផ្ទះ មិនភ្នាល់",
  BS_TWTN: "ឈ្នះដោយគ្មានការដាក់គ្រាប់",
  BS_OR: "ជើងឯក",
  BS_ORZ: "ជើងឯក",

  LOT_BS: "ធំ/តូច",
  LOT_BIG: "ធំ",
  LOT_SMALL: "តូច",
  LOT_OE: "គូ/សេស",
  LOT_ODD: "សេស",
  LOT_EVEN: "គូ",
  LOT_OU: "លើស/ក្រោម",
  LOT_OVER: "លើស",
  LOT_UNDER: "ក្រោម",
  LOT_1: "ម្ចាស់ផ្ទះ",
  LOT_0: "ភ្ញៀវ",
  LOT3_OVER: "លើស",
  LOT3_UNDER: "ក្រោម",

  D_1: "លេខតែ១",
  D_2: "លេខ & ប្រែស្រឡាយ",
  D_3: "ប្រអប់",
  D_4: "iBox",
  D_5: "ប្រអប់ ៣ ខ្ទង់ចុងក្រោយ",
  D_6: "ប្រអប់ ២ ខ្ទង់ចុងក្រោយ",

  D_BIG: "ធំ",
  D_SMALL: "តូច",
  D_AA: "AA",
  D_SA: "A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "ABC",

  GH_1X2: "ឈ្នះ",
  GH_1X20: "ឈ្នះ",
  GH_1X2HDP: "លេខទីពីរ/លេខទីបី",
  GH_1X2HDP2: "លេខទីពីរ",
  GH_1X2HDP4: "លេខទីបី",
  GH_OVER: "លើស (4,5,6)",
  GH_UNDER: "ក្រោម (1,2,3)",
  GH_ODD: "សេស (1,3,5)",
  GH_EVEN: "គូ (2,4,6)",
  GH_OU1: "លើស (4,5,6)",
  GH_OU2: "ក្រោម (1,2,3)",
  GH_OE1: "សេស (1,3,5)",
  GH_OE2: "គូ (2,4,6)",

  GX_1X2: "ឈ្នះ",
  GX_1X20: "ឈ្នះ",
  GX_1X2HDP: "លេខទីពីរ/លេខទីបី",
  GX_1X2HDP2: "លេខទីពីរ",
  GX_1X2HDP4: "លេខទីបី",
  GX_OVER: "លើស (7-12)",
  GX_UNDER: "ក្រោម (1-6)",
  GX_ODD: "សេស (1,3,5,7,9,11)",
  GX_EVEN: "គូ (2,4,6,8,10,12)",
  GX_OU1: "លើស (7-12)",
  GX_OU2: "ក្រោម (1-6)",
  GX_OE1: "សេស (1,3,5,7,9,11)",
  GX_OE2: "គូ (2,4,6,8,10,12)",

  GC_OU: "លើស/ក្រោម",
  GC_OE: "គូ/សេស",
  GC_OVER: "លើស (3,4,5)",
  GC_UNDER: "ក្រោម (0,1,2)",
  GC_ODD: "សេស (1,3,5)",
  GC_EVEN: "គូ (0,2,4)",
  GC_5_0: "5-0",
  GC_4_1: "4-1",
  GC_3_2: "3-2",
  GC_0_5: "0-5",
  GC_1_4: "1-4",
  GC_2_3: "2-3",
  GC_ML0: "បាល់ទី១",
  GC_1X20: "ឈ្នះ",
  GC_ML: "បាល់ទី១",
  GC_1X2: "ឈ្នះ",
  GC_OU1: "លើស (3,4,5)",
  GC_OU2: "ក្រោម (0,1,2)",
  GC_OE1: "សេស (1,3,5)",
  GC_OE2: "គូ (0,2,4)",

  ROOM_A: "បើក",
  ROOM_0: "សកម្ម",
  ROOM_1: "បិទ",
  ROOM_2: "បោះបង់",
  ROOM_3: "បញ្ចប់",
  ROOM_4: "ផ្អាកការភ្នាល់",
  ROOM_10: "ទាំងអស់",

  ROOM_T0: "ទាំងអស់",
  ROOM_T1: "បន្ទប់សាធារណៈ",
  ROOM_T2: "បន្ទប់ឯកជន",
  ROOM_T3: "បន្ទប់ឥតគិតថ្លៃ",

  joinRoom1: "ចូលបន្ទប់សាធារណៈ",
  joinRoom2: "ចូលបន្ទប់ឯកជន",
  joinRoom3: "ចូលបន្ទប់ឥតគិតថ្លៃ",
  createRoom1: "បង្កើតបន្ទប់សាធារណៈ",
  createRoom2: "បង្កើតបន្ទប់ឯកជន",
  createRoom3: "បង្កើតបន្ទប់ឥតគិតថ្លៃ",
  Champion: "ជើងឯក",
  FirstRunnerUp: "ទី ២",
  SecondRunnerUp: "ទី ៣",

  BT_OEHM: "គូ/សេស របស់ម្ចាស់ផ្ទះ",
  BT_OEHMH: "គូ/សេស បាតទី១ របស់ម្ចាស់ផ្ទះ",
  BT_OEAW: "គូ/សេស របស់ភ្ញៀវ",
  BT_OEAWH: "គូ/សេស បាតទី១ របស់ភ្ញៀវ",

  BS_OEHM: "គូ/សេស បាតពេញ របស់ម្ចាស់ផ្ទះ",
  BS_OEHMH: "គូ/សេស បាតទី១ របស់ម្ចាស់ផ្ទះ",
  BS_OEAW: "គូ/សេស បាតពេញ របស់ភ្ញៀវ",
  BS_OEAWH: "គូ/សេស បាតទី១ របស់ភ្ញៀវ",
};
